import moment from "moment";
import React from "react";
import { formatTime } from "utilities";

interface Props {
  localTime: Date
  timeZone: server.dto.TimeZone
}

const LocalTimeRow = ({ localTime, timeZone }: Props) => {
  return <div>
    <span>{formatTime(moment.utc(localTime))}</span>
    <div className="text-sublabel">({timeZone.utcOffset}) {timeZone.displayName} ({timeZone.value})</div>
  </div>
};

export default LocalTimeRow;